// extracted by mini-css-extract-plugin
export default {"Wrapper":"DropDownHeaderMenu_Wrapper__OFE7g","Inner":"DropDownHeaderMenu_Inner__BlRKX","Content":"DropDownHeaderMenu_Content__hpIQ8"};